(() => {
  if (customElements.get('wk-cart-assist')) return;
  let adding = false;

  class CartAssist extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const { base, currency, threshold, subtotal, mode } = this.dataset;
      const market = window.Shopify?.currency;
      const rate = currency === base ? 1 : market?.active === currency ? Number(market.rate) : 0;
      const target = Math.ceil(Number(threshold) * rate - 1e-8);
      if (!Number.isFinite(target) || target <= 0) return;
      this.gap = Math.max(0, target - Number(subtotal));
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code' });

      if (mode === 'progress') {
        if (Number(this.dataset.saved) > 0 || this.dataset.competing === 'true') return;
        const meter = this.querySelector('progress');
        if (!meter) return;
        meter.value = 100 * (target - this.gap) / target;
        meter.hidden = false;
        if (currency === base) return;
        const message = this.dataset.estimate;
        this.querySelector('[data-message]').textContent = this.gap
          ? message.replace('__AMOUNT__', this.format(this.gap))
          : this.dataset.qualified;
        return;
      }
      if (this.gap === 0) return;
      const candidates = [...this.querySelectorAll('template[data-candidate]')].map(template => ({
        template, price: Number(template.dataset.price), affinity: Number(template.dataset.affinity)
      }));
      candidates.sort((a, b) => {
        const crossesA = a.price >= this.gap;
        const crossesB = b.price >= this.gap;
        if (crossesA !== crossesB) return crossesA ? -1 : 1;
        return Math.abs(a.price - this.gap) - Math.abs(b.price - this.gap) || b.affinity - a.affinity;
      });
      if (!candidates.length) return;
      const list = this.querySelector('[data-cards]');
      for (const candidate of candidates.slice(0, 2)) {
        const card = candidate.template.content.firstElementChild.cloneNode(true);
        const select = card.querySelector('[data-variant]');
        const label = card.querySelector('[data-only-option]');
        if (label) label.textContent = select.selectedOptions[0]?.textContent || '';
        this.updateCard(card);
        list.appendChild(card);
      }
      this.addEventListener('change', event => {
        if (event.target.matches('[data-variant]')) this.updateCard(event.target.closest('.wk-pick'));
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-add]');
        if (button) this.add(button);
      });
      this.hidden = false;
    }

    format(cents) { return this.money.format(cents / 100); }

    updateCard(card) {
      const select = card.querySelector('[data-variant]');
      const option = select.selectedOptions[0];
      card.querySelector('[data-add]').disabled = !select.value;
      const amount = Number(select.value ? option.dataset.price : card.dataset.low);
      if (select.value && String(amount) !== card.dataset.shown) {
        const money = document.createElement('span');
        money.className = 'money';
        money.textContent = option.dataset.label;
        card.querySelector('[data-price-label]').replaceChildren(money);
        card.dataset.shown = String(amount);
      }
      card.querySelector('[data-hint]').textContent = amount >= this.gap
        ? this.dataset.ready
        : this.dataset.left;
    }

    async add(button) {
      if (adding || button.disabled) return;
      const select = button.closest('.wk-pick').querySelector('[data-variant]');
      const id = Number(select.value);
      if (!Number.isSafeInteger(id) || id <= 0) return;
      const root = window.Shopify.routes.root;
      const alert = this.querySelector('[data-error-message]');
      const sections = [];
      const html = document.documentElement;
      html.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      adding = true;
      let added = false;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      alert.hidden = true;
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: [...new Set(sections)].slice(0, 5), sections_url: location.pathname })
        });
        added = response.ok;
        const payload = await response.json();
        if (!response.ok) {
          alert.textContent = payload.description || this.dataset.error;
          alert.hidden = false;
          return;
        }
        const announcement = document.getElementById('status-announcement');
        if (announcement) announcement.textContent = this.dataset.added;
        if (window.themeVariables?.settings?.pageType === 'cart') {
          location.reload();
          return;
        }
        const current = await fetch(root + 'cart.js', { cache: 'no-store' });
        if (!current.ok || !payload.sections || Object.values(payload.sections).some(value => !value)) throw new Error();
        const cart = await current.json();
        cart.sections = payload.sections;
        html.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart, baseEvent: 'wk-cart:add' } }));
      } catch {
        if (added) { location.assign(root + 'cart'); return; }
        alert.textContent = this.dataset.error;
        alert.hidden = false;
      } finally {
        adding = false;
        if (!added) button.disabled = !select.value;
        button.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('wk-cart-assist', CartAssist);
})();
